import { Component, OnInit, Input } from "@angular/core";
import { ConsensusSummaryDataService } from "../../consensus-summary-data.service";
import { catchError } from "rxjs/operators";
import { throwError, Subscription } from "rxjs";
import { TargetPriceConsensus } from "../../interfaces";

@Component({
  selector: "app-target-price-consensus",
  templateUrl: "./target-price-consensus.component.html",
  styleUrls: ["./target-price-consensus.component.scss"],
})
export class TargetPriceConsensusComponent implements OnInit {
  @Input() primaryTicker = "";
  @Input() brokerInTPConsensus: number;
  @Input() totalBroker: number;
  //subscribers
  tprTargetPriceConensusSubsciber: Subscription;

  constructor(private dataService: ConsensusSummaryDataService) {}

  data: TargetPriceConsensus = {};
  lTM_return_display: number;
  current_implied_return_display: number;
  hasConsensus: boolean;
  curreny_symbol: string;
  TPConsensusDataReady = false;

  ngOnInit() {
    this.getTargetPriceConsensus();
  }

  getTargetPriceConsensus = (): void => {
    this.TPConsensusDataReady = false;
    this.tprTargetPriceConensusSubsciber = this.dataService
      .getTargetPriceConsensus(this.primaryTicker)
      .pipe(
        catchError((err) => {
          return throwError(err);
        }),
      )
      .subscribe((response: any) => {
        if (response && response["status"] === "success") {
          this.data = response["data"][this.primaryTicker];
          this.current_implied_return_display = Math.abs(
            this.data.current_implied_return,
          );
          this.lTM_return_display = Math.abs(this.data.LTM_return);
          this.hasConsensus = this.data.has_current_consensus;
          this.curreny_symbol = this.data.display_cur || "";
          this.TPConsensusDataReady = true;
        }
      });
  };

  getClassOf = (value: number): string => {
    switch (true) {
      case value < 0:
        return "red";
      case value > 0:
        return "green";
      case value === 0:
        return "black";
      default:
        return "black";
    }
  };

  getClassOfTargetPrice = (value: number): string => {
    switch (true) {
      case value === this.data.prev_close:
        return "black";
      case value < this.data.prev_close:
        return "red";
      case value > this.data.prev_close:
        return "green";
      case value === 0:
        return "black";
      default:
        return "black";
    }
  };

  ngOnDestroy() {
    if (this.tprTargetPriceConensusSubsciber) {
      this.tprTargetPriceConensusSubsciber.unsubscribe();
    }
  }
}
